
import Vue from "vue";
import { IBreadCrumb } from "../classes/bread-crumb";

export default Vue.extend({
	props: {
		crumbs: Array as () => IBreadCrumb[]
	},
	methods: {
		onClick(crumb:IBreadCrumb) {
			this.$emit("click", crumb);
		}
	}
});
